import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";


import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from "ngx-toastr";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ContentLayoutComponent } from "./layouts/content/content-layout.component";
import { FullLayoutComponent } from "./layouts/full/full-layout.component";
import { SharedModule } from "./shared/shared.module";

import { HttpClient, provideHttpClient } from "@angular/common/http";
import { NgScrollbarModule } from 'ngx-scrollbar';
import { AuthDataService } from "./shared/auth/auth-data.service";
import { AuthGuard } from "./shared/auth/auth-guard.service";
import { AuthService } from "./shared/auth/auth.service";
import { LoadingOverlayModule } from "./shared/components/loading-overlay/loading-overlay.module";
import { GlobalErrorHandler } from "./shared/handlers/global-error-handler";
import { WINDOW, windowFactory } from "./shared/services/window.service";
import { AppConfigConstants, AppConfigLoader } from "./shared/settings/app-config-loader";
import { AppConfigService } from "./shared/settings/app-config.service";



export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [AppComponent, FullLayoutComponent, ContentLayoutComponent],
  imports: [
    NgScrollbarModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    ToastrModule.forRoot({
      maxOpened: 5,
      closeButton: true,
      timeOut: 3000,
      progressBar: true,
      progressAnimation: 'decreasing'
    }),
    NgbModule,
    LoadingOverlayModule,
    NgxSpinnerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    AuthService,
    AuthDataService,
    AuthGuard,
    { provide: WINDOW, useFactory: windowFactory },
    { provide: APP_INITIALIZER, useFactory: AppConfigLoader, deps: [AppConfigService], multi: true },
    { provide: APP_INITIALIZER, useFactory: AppConfigConstants, deps: [AppConfigService], multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideHttpClient(),
    AppConfigService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
